var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminateRent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14359",
    "data-name": "Group 14359",
    transform: "translate(0.75 1.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus-circle",
    transform: "translate(0 -0.271)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 8,
    transform: "translate(8.5 12.5)",
    fill: "none",
    stroke: "var(--theme-text)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminateRent);
export default __webpack_public_path__ + "static/media/terminateRent.60f2646fd222b318d8ae81c37edbebb8.svg";
export { ForwardRef as ReactComponent };